import React from "react";
import { Card, Empty, Spin, Typography } from "antd";
import { Pie } from "@ant-design/plots";
import { LoadingOutlined } from "@ant-design/icons";

const { Title } = Typography;
const antIcon = <LoadingOutlined spin />;

const ConnectedProtocolsChart = ({ data, loading, cardStyle }) => {
  const config = {
    data,
    appendPadding: 10,
    height: 330,
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    pieStyle: {
      fillOpacity: 0.8,
      lineWidth: 0,
    },
    label: {
      type: "outer",
      content: "{name} {percentage}",
    },
  };

  return (
    <Card className="custom-card-graph" title={<Title level={3}>Connected Protocols</Title>} style={{ width: '100%', ...cardStyle }} bodyStyle={{ minHeight: 220, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Spin
        indicator={antIcon}
        spinning={loading}
        style={{ width: '100%' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          {data.length ? <Pie {...config} style={{ width: '100%' }} /> : <Empty style={{ width: '100%' }} />}
        </div>
      </Spin>
    </Card>
  );
};

export default ConnectedProtocolsChart;
